import { render } from "./Edicion.vue?vue&type=template&id=62cb4746"
import script from "./Edicion.vue?vue&type=script&lang=js"
export * from "./Edicion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__